import { render, staticRenderFns } from "./metta-community.vue?vue&type=template&id=7630eb6e&scoped=true"
import script from "./metta-community.vue?vue&type=script&lang=js"
export * from "./metta-community.vue?vue&type=script&lang=js"
import style0 from "./metta-community.vue?vue&type=style&index=0&id=7630eb6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630eb6e",
  null
  
)

export default component.exports